export default __webpack_public_path__ + "media/images/logo/sns/twitter-3ffbc0b883890e10940b199a8b93f0f4.png";